import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SignoPadronesService } from 'src/app/services/entidades/signo-padrones.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-padones-historial',
  templateUrl: './padones-historial.component.html',
  styleUrls: ['./padones-historial.component.scss']
})
export class PadonesHistorialComponent implements OnInit {
  histories: any[] = [];
  isLoading = true;

  constructor(
    private padronesService: SignoPadronesService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadHistory();
  }

  async loadHistory() {
    this.isLoading = true;
    try {
      this.histories = await this.padronesService.getImportHistory();
    } catch (error) {
      console.error('Error loading import history:', error);
      Swal.fire('Error', 'No se pudo cargar el historial de importaciones', 'error');
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  tipoLabel(tipo: string): string {
    switch (tipo) {
      case 'FARMACIAS': return 'FARMACIAS';
      case 'PADRON_MDP': return 'PADRÓN MDP';
      case 'HIPOCRATES': return 'HIPÓCRATES';
      case 'COMPANIA_FARMACEUTICA': return 'COMPAÑÍA FARMACÉUTICA';
      default: return tipo;
    }
  }

  tipoBadgeClass(tipo: string): string {
    switch (tipo) {
      case 'FARMACIAS': return 'badge-success';
      case 'HIPOCRATES': return 'badge-info';
      case 'COMPANIA_FARMACEUTICA': return 'badge-warning';
      default: return 'badge-primary';
    }
  }

  tipoIcon(tipo: string): string {
    switch (tipo) {
      case 'FARMACIAS': return 'fa-pills';
      case 'HIPOCRATES': return 'fa-stethoscope';
      case 'COMPANIA_FARMACEUTICA': return 'fa-industry';
      default: return 'fa-file-medical';
    }
  }

  tipoBorderColor(tipo: string): string {
    switch (tipo) {
      case 'FARMACIAS': return '#28a745';
      case 'HIPOCRATES': return '#17a2b8';
      case 'COMPANIA_FARMACEUTICA': return '#ffc107';
      default: return '#007bff';
    }
  }

  async confirmClearHistory() {
    const result = await Swal.fire({
      title: '¿Está seguro de borrar todo el historial?',
      text: 'Esta acción no se puede deshacer y eliminará todos los registros históricos de importaciones.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, borrar todo',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await this.padronesService.clearImportHistory();
        Swal.fire('¡Eliminado!', 'El historial ha sido borrado con éxito.', 'success');
        await this.loadHistory();
      } catch (error) {
        console.error('Error clearing history:', error);
        Swal.fire('Error', 'No se pudo borrar el historial', 'error');
      }
    }
  }
}
